import React from 'react';
const initialState = {
    view: 'assessment',
    setView: () => { },
};
const NavigationContext = React.createContext(initialState);
export const NavigationProvider = ({ children }) => {
    const [view, setView] = React.useState('assessment');
    const value = React.useMemo(() => ({
        view,
        setView,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [view]);
    return React.createElement(NavigationContext.Provider, { value: value }, children);
};
export const useNavigation = () => {
    const context = React.useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
};
